import { useState } from "react";
import type { CommentProviderProps } from "./types";

export const useComment = ({
    subject,
    onChange,
    onAddComment,
    onSubmitComments,
    comments: messages = []
}: CommentProviderProps) => {
    const [message, setMessage] = useState<string>('');
    const [comments, setComments] = useState<Array<string>>(messages);

    const changeMessage = (message: string) => {
        setMessage(message);

        onChange({
            subject,
            message
        });
    };

    const addMessage = () => {
        const commentMessage = String(message).trim();

        setComments(comments => [...comments, commentMessage]);

        onAddComment({
            subject,
            message: commentMessage
        });

        setMessage('');
    };

    const submitComments = () =>
        onSubmitComments({
            subject,
            comments
        });

    const deleteMessage = (messageIndex: number) => (
        setComments(comments => comments.filter((_, index) => !Object.is(index, messageIndex)))
    );

    return {
        message,
        comments,
        changeMessage,
        addMessage,
        submitComments,
        deleteMessage
    };
};

export default useComment;
